import React from 'react';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  FormColumn,
  FormRowGroup,
} from 'modules/tickets/components/common/dialog/TicketFormUtils';
import Button from 'app/commonComponents/Button';
import { SuccessIcon } from 'app/commonComponents/icons';
import { colors } from 'app/variables';
import form from 'modules/ticketPublicPage/stores/vouchers/form';

const WithdrawalSuccess = observer(() => {
  const history = useHistory();
  const location = useLocation();

  const handleBuyAnotherVoucher = () => {
    form.setFormDefaults();
    form.isWithdrawal = false;
    form.step = form.INITIAL;

    history.push(location.pathname.replace(/\/withdrawal\/?$/, ''));
  };

  return (
    <FormRowGroup style={{ width: '100%' }}>
      <FormColumn
        style={{
          width: '100%',
          display: 'flex',
          gap: '4rem',
          textAlign: 'center',
          marginBlock: '20% 10%',
        }}
      >
        <div>
          <SuccessIcon
            style={{
              color: colors.pacificBlue,
              height: '6rem',
              width: '6rem',
              margin: '1.5rem auto 1rem',
            }}
          />
          <div style={{ color: colors.pacificBlue, marginBottom: '1.25rem' }}>
            {i18n.gettext('You will receive a confirmation email shortly')}
          </div>
        </div>
        <Button
          color={colors.pacificBlue}
          onClick={handleBuyAnotherVoucher}
          style={{ margin: '0 auto', padding: '0.75rem 2rem', width: '90%' }}
        >
          {i18n.gettext('Buy another voucher')}
        </Button>
      </FormColumn>
    </FormRowGroup>
  );
});

export default WithdrawalSuccess;
